import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import CardStore from '../Card/CardStore'

class ShowcaseUnidade extends Component {
  render () {
    return (
      <Fragment>
        <div className='p0-mob'>
          <div className='overflowHidden mt-3'>
            <p className='floatLeft mt-2 titleOfertas'>lojas pertinho de você</p>
            {this.props.showcaseType !== 'ecommerce'
              ? <div
                className='buttonClickCep floatRight'
                onClick={this.props.handleOpenDialogGeoLocation}
              >
                <i className='icon icon_location' />
              ativar localização
              </div> : ''}
          </div>
        </div>
        <div className='d-flex flex-direct-b'>
          { this.props.unitys && this.props.unitys.data.slice(0, 4).map((unity, ix) => (
            <CardStore {...unity} key={ix} location={this.props.location} />
          )) }

          <div
            className='btn-cards-mBairro mobile'
            onClick={() => {
              window.open('https://www.itau.com.br/', '_self')
            }}
          >
        Ver todas
          </div>
        </div>
      </Fragment>
    )
  }
}

ShowcaseUnidade.propTypes = {
  unitys: PropTypes.array,
  handleOpenDialogGeoLocation: PropTypes.func,
  location: PropTypes.bool,
  showcaseType: PropTypes.string
}
export default ShowcaseUnidade



// WEBPACK FOOTER //
// ./src/features/MeuBairro/showcases/showcaseUnidade.js